<template>
  <v-card-actions class="card-bg-2">

    <template v-if="editForm">
      <PrimaryBtn color="success" @click="save()" icon="done">
        {{ $t('Button.Save') }}
      </PrimaryBtn>
      <SecondaryBtn @click="cancelEdit()">
        {{ $t('Button.Cancel') }}
      </SecondaryBtn>
    </template>
    <template v-else>
      <template v-if="isTenantAdmin && !file.IsArchived">
        <SecondaryBtn color="warning" @click="setEdit(true)" icon="edit">
          {{ $t('Button.Edit_Metadata') }}
        </SecondaryBtn>
        <v-divider vertical class="mx-2" />
      </template>
      <SecondaryBtn icon="save_alt" color="info" @click="onDownload()">
        {{ $t('Button.Download') }}
      </SecondaryBtn>

      <template v-if="(isSystemAdmin || isTenantAdmin) && file.ImportId == null">
        <DeleteFileAction @reload="$emit('reload')" v-if="isTenantAdmin" #default="{ submit, loading }">
          <SecondaryBtn class="ml-2" @click="submit(formFile.Id)" :loading="loading" color="error" icon="mdi-delete" :disabled="!allowReingestion || file.ImportId != null || file.IsArchived">
            Delete File
          </SecondaryBtn>
        </DeleteFileAction>        
        <v-divider vertical class="mx-2" />
      </template>

      

      <IngestRdrFileAction @reload="$emit('reload')" v-if="isTenantAdmin" #default="{ submit, loading }">
        <SecondaryBtn class="ml-2" @click="submit(formFile.Id)" :loading="loading" color="info" icon="publish" :disabled="!allowReingestion || file.IsArchived">
          {{ reviewIngestionLink ? 'Reingest data' : 'Ingest data' }}
        </SecondaryBtn>
      </IngestRdrFileAction>

      <AutoDetectFileAction @reload="$emit('reload')" v-if="isTenantAdmin" no-next>
        <template #default="{ submit, loading }">
          <SecondaryBtn class="ml-2" @click="submit(formFile.Id)" :loading="loading" color="info" icon="preview" :disabled="file.IsArchived">
            Auto-detect file type
          </SecondaryBtn>
        </template>
      </AutoDetectFileAction>     

      <SecondaryBtn class="ml-2" v-if="reviewIngestionLink" :to="reviewIngestionLink" color="info" icon="rule" :disabled="file.IsArchived || file.ImportId != null">
        Review file
      </SecondaryBtn>

      <template v-if="(isSystemAdmin || isTenantAdmin) && file.ImportId != null && file.IsExecute && !file.IsArchived">
        <v-divider vertical class="mx-2" />
        <RollbackImportAction class="ml-2" v-if="(isSystemAdmin || isTenantAdmin) && file.ImportId != null && file.IsLatestVersion && file.IsExecute" :importId="file.ImportId" />
      </template>

      <template v-if="file.IsExecute && !file.IsArchived">  
        <v-divider vertical class="mx-2" />
        <ExecutionFileVersionChip @click:version="goToFilterVersion($event)" small :fileVersions="file.RelatedFileVersions" :isLatestVersion="file.IsLatestVersion" />
      </template>

    </template>
  </v-card-actions>

</template>

<script>
  import { download } from '@/helpers/download'
  import { getIngestionLink, getIngestionResultsLink } from '@/helpers/datasets/ingestions'
  import { createNamespacedHelpers } from 'vuex'

  const app = createNamespacedHelpers('app')
  const authenticate = createNamespacedHelpers('authenticate')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')
  const ingestions = createNamespacedHelpers('ingestions')

  export default {
    props: {
      file: Object,
      formFile: Object,
      editForm: Boolean,
    },
    data: () => ({}),
    computed: {
      ...authenticate.mapGetters(['isSystemAdmin', 'isTenantAdmin']),
      ...rawdatarepository.mapGetters([
        'metadataSchemas',
        'metadataSchemaById',
      ]),  
      reviewIngestionLink() {
        if (!this.file) return null
        let ingestionLink = getIngestionLink(this.file)
        return ingestionLink
      },
      viewIngestionResultsLink() {
        let ingestionResultsLink = getIngestionResultsLink(this.file)
        return ingestionResultsLink
      },
      allowReingestion() {
        if (!this.file) {
          return false
        } else if(this.schema != null && this.schema.Name == 'Report') {
          return false
        } else if(this.reviewIngestionLink == null) {
          return true
        } else {
          return !this.reviewIngestionLink
        }
      },
      schema() {
        var matchedSchemas = this.metadataSchemaById(this.file.SchemaId)
        return matchedSchemas.length > 0 ?
          JSON.parse(JSON.stringify(matchedSchemas[0])) :
          null
      },
    },
    methods: {          
      ...rawdatarepository.mapActions(['getFileById', 'putFile']),
      ...ingestions.mapActions(['ingestFiles']),
      ...app.mapActions(['setSnackbar']),
      onDownload() {
        download(
          `api/RawDataRepository/file/${this.formFile.Id}/download`,
          this.formFile.Name, {
            successful: () => null,
          }
        )
      },
      setEdit(val) {
        this.$emit('update:edit', val)
      },
      cancelEdit() {
        this.$emit('cancel:edit')
      },
      save() {
        this.setEdit(false)
        this.metadataUpdateError = false

        let options = {
          fileId: this.file.Id,
          payload: this.formFile,
          successCb: () => {
            this.$emit('reload')
            this.setSnackbar({
              color: 'success',
              text: `File ${this.file.Name} updated successfully`,
            })
          },
          failedCb: (msg, err) => {
            console.error(msg)
            if (err.response.status == 400) {
              this.$emit('error', err.response.data)
            } else {
              this.setSnackbar({
                color: 'error',
                text: 'Error occurred updating file: ' + msg,
              })
            }
          },
        }
        this.putFile(options)
      },
      goToFilterVersion(version) {
        this.$router.push({ name: 'allimports', query: { search: version.id } })
      },
    },
  }
</script>